import { startStimulusApp, registerControllers } from "vite-plugin-symfony/stimulus/helpers";
import LiveController from '@symfony/ux-live-component';
import '@symfony/ux-live-component/dist/live.min.css';

const app = startStimulusApp();

// Register the Live Component controller
app.register('live', LiveController);

// Register your custom controllers
registerControllers(
    app,
    import.meta.glob('./controllers/*_controller.js', {
        query: "?stimulus",
        /**
         * always true, the `lazy` behavior is managed internally with
         * import.meta.stimulusFetch (see reference)
         */
        eager: true,
    })
)
